var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.06,79.85H136l6.1,7m12.54,66h-18l-6.32,5.87m-18.49-24.38h25l11.72-12m-12.63-12h22.79M111.6,49.9V176.79s43,11.05,43-23.93c18.28.22,27.08-30,5.42-42.22,0,0,11.95-38.38-11.73-43.12,0,0-12.18-1.58-12.18-12.87S117.54,37.26,111.6,49.9ZM98.24,79.85H74.33l-6.09,7m-11.82,66H74.48l6.31,5.87m18.5-24.38h-25l-11.74-12m12.64-12H52.37M99.43,49.9V176.79s-43,11.05-43-23.93c-18.26.22-27.06-30-5.4-42.22,0,0-12-38.38,11.72-43.12,0,0,12.18-1.58,12.18-12.87S93.49,37.26,99.43,49.9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/BRAIN.6c9f17911ab1bb4ae1ad9c2505410d54.svg";
export { ForwardRef as ReactComponent };